import { useEffect } from 'react';

interface SEOMeta {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
  twitterCard?: string;
}

export default function useSEOMeta(meta: SEOMeta) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = meta.title;

    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    setMetaTag('description', meta.description);
    if (meta.keywords) setMetaTag('keywords', meta.keywords);

    if (meta.canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', meta.canonicalUrl);
    }

    setMetaTag('og:title', meta.ogTitle || meta.title, true);
    setMetaTag('og:description', meta.ogDescription || meta.description, true);
    setMetaTag('og:type', meta.ogType || 'website', true);
    if (meta.ogImage) setMetaTag('og:image', meta.ogImage, true);

    setMetaTag('twitter:card', meta.twitterCard || 'summary_large_image');
    setMetaTag('twitter:title', meta.ogTitle || meta.title);
    setMetaTag('twitter:description', meta.ogDescription || meta.description);

    return () => {
      document.title = prevTitle;
    };
  }, [meta]);
}